/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccounttUpsertMutation($vendorAccounttId: ID, $vendorAccounttDirectoryId: ID, $vendorAccountt: [ID!]!, $displayName: String!) {
  VendorAccounttUpsert(vendorAccounttId: $vendorAccounttId, vendorAccounttDirectoryId: $vendorAccounttDirectoryId, vendorAccountt: $vendorAccountt, displayName: $displayName) {
    id
    message
    status
  }
}
`
